import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const generateFmeaAction = async ({
  failureMode,
  rootCause,
  impact,
  linkedParties,
  severity,
  sourceIncident,
}) => {
  const res = await axios.post(
    `${API}/fmea/generate-action`,
    {
      failure_mode: failureMode,
      root_cause: rootCause,
      impact,
      linked_parties: linkedParties,
      severity,
      source_incident: sourceIncident,
    },
    { timeout: 45000 }
  );
  return res.data;
};

export const scoreFmeaRpn = async ({
  failureMode,
  failureEffect,
  potentialCause,
  currentControls,
  incidentSeverity,
  productionImpact,
}) => {
  const res = await axios.post(
    `${API}/fmea/score-rpn`,
    {
      failure_mode: failureMode,
      failure_effect: failureEffect,
      potential_cause: potentialCause,
      current_controls: currentControls,
      incident_severity: incidentSeverity,
      production_impact: productionImpact,
    },
    { timeout: 45000 }
  );
  return res.data;
};

export const generateFmeaFrom8D = async ({
  eightDId,
  failureTitle,
  d4RootCause,
  d4EscapeRoot,
  d5CorrectiveActions,
  d5NonDetectionActions,
  sourceIncident,
  affectedParties,
}) => {
  const res = await axios.post(
    `${API}/fmea/generate-from-8d`,
    {
      eight_d_id: eightDId,
      failure_title: failureTitle,
      d4_root_cause: d4RootCause,
      d4_escape_root: d4EscapeRoot,
      d5_corrective_actions: d5CorrectiveActions,
      d5_non_detection_actions: d5NonDetectionActions,
      source_incident: sourceIncident,
      affected_parties: affectedParties,
    },
    { timeout: 45000 }
  );
  return res.data;
};
